import api from './interceptor';

const BASE_URL_V2 = 'api/v2/inventory';

export default {
  // API Version 2
  getInventories: params => api.get(`${BASE_URL_V2}`, { params }),
  getInventory: serialNumber => api.get(`${BASE_URL_V2}/${serialNumber}`),
  existInventory: serialNumber => api.get(`${BASE_URL_V2}/exists/${serialNumber}`),
  createInventory: params => api.post(`${BASE_URL_V2}`, params),
  editInventory: (serialNumber, params) => api.put(`${BASE_URL_V2}/${serialNumber}`, params),
  deleteInventory: serialNumber => api.delete(`${BASE_URL_V2}/${serialNumber}`),
};
